module.exports = __webpack_public_path__ + "static/media/GameThumbnail.a8eb1ecd.jpg";